import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { getAuth, onAuthStateChanged, User } from 'firebase/auth';
import { getFirebaseApp } from '../core/firebase';
import { OrgContextService } from '../core/services/org-context.service';
import { regionUnavailableRedirect } from './permission.guard';

function retrieveUser(): Promise<User | null> {
  const auth = getAuth(getFirebaseApp());
  return new Promise((resolve) => {
    const unsub = onAuthStateChanged(auth, (user) => {
      unsub();
      resolve(user && !user.isAnonymous ? user : null);
    });
  });
}

export const usageAccessGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const orgContext = inject(OrgContextService);
  const unavailable = regionUnavailableRedirect();
  if (unavailable) return unavailable;

  if (!orgContext.currentOrg()) {
    return router.parseUrl('/new');
  }

  // @crewdle.com admins can view any org's usage via ?orgId=<id>
  const orgIdParam = route.queryParamMap.get('orgId');
  if (orgIdParam) {
    const user = await retrieveUser();
    if (user?.email?.endsWith('@crewdle.com')) {
      return true;
    }
  }

  const has = await orgContext.checkPermission('analytics.read');
  return has || router.parseUrl(orgContext.orgUrl('/home'));
};
